import { get } from 'lodash';
import {
  LAYOUT_TYPE_PATH,
  CARD_SIZE_PATH,
  IS_MAIN_PAGE_HEADER_ENABLED,
  IS_HEADER_ENABLED,
  MAIN_PAGE_HEADER_HEIGHT,
  HEADER_HEIGHT,
} from '../constants/wix-params';
import { UPDATE_APP_SETTINGS_REQUEST } from '../../common/store/app-settings/app-settings-actions';
import getLayoutName from '../services/get-layout-name';
import {
  PICK_FORUM_SUBJECT,
  CHOOSE_FORUM_STRUCTURE,
  CUSTOMIZE_RCE,
  CUSTOMIZE_FEED,
  LOGIN_FROM_FORUM,
  SHOW_HEADER,
  RESIZE_HEADER,
  DELETE_CATEGORY,
  SELECT_FONT,
  SELECT_FONT_SIZE,
  CREATE_CATEGORY,
  EDIT_CATEGORY,
} from '../actions/user-events';
import { getCategory } from '../selectors/categories-selectors';

export const eventMap = {
  [UPDATE_APP_SETTINGS_REQUEST]: action => {
    if (action.meta && action.meta.bi && action.meta.bi.externalId !== 'draft') {
      return {
        evid: 12,
        setting_input_json: JSON.stringify({
          layoutName: getLayoutName(
            get(action.payload, LAYOUT_TYPE_PATH),
            get(action.payload, CARD_SIZE_PATH),
          ),
        }),
      };
    }
  },
  [PICK_FORUM_SUBJECT]: action => ({
    evid: 41,
    type_of_subject: action.payload,
  }),
  [CHOOSE_FORUM_STRUCTURE]: action => ({
    evid: 302,
    type: action.payload ? 'ListOfCategories' : 'ListOfAllPosts',
  }),
  [CUSTOMIZE_RCE]: action => ({
    evid: 565,
    feature: action.payload.plugin,
    type: action.payload.isEnabled ? 'on' : 'off',
  }),
  [CUSTOMIZE_FEED]: action => ({
    evid: 44,
    activity_type: action.payload.type,
    type: action.payload.isEnabled ? 'on' : 'off',
  }),
  [LOGIN_FROM_FORUM]: action => ({
    evid: 45,
    option: action.payload ? 'on' : 'off',
  }),
  [SHOW_HEADER]: action => {
    const origin = action.payload.origin;
    const isEnabled = action.payload.isEnabled;

    if (origin === IS_MAIN_PAGE_HEADER_ENABLED) {
      return {
        evid: 42,
        option: isEnabled ? 'on' : 'off',
        origin: 'mainPage',
      };
    }
    if (origin === IS_HEADER_ENABLED) {
      return {
        evid: 42,
        option: isEnabled ? 'on' : 'off',
        origin: 'postsPage',
      };
    }
  },
  [RESIZE_HEADER]: action => {
    const origin = action.payload.origin;
    const size = action.payload.size;

    if (origin === MAIN_PAGE_HEADER_HEIGHT) {
      return {
        evid: 43,
        height: size,
        origin: 'mainPage',
      };
    }
    if (origin === HEADER_HEIGHT) {
      return {
        evid: 43,
        height: size,
        origin: 'postsPage',
      };
    }
  },
  [DELETE_CATEGORY]: (action, state) => {
    const category = getCategory(state, action.payload.categoryId);
    return {
      application_type: 'web',
      evid: 34,
      name: category.label,
      origin: action.payload.origin,
      type: category.parentId ? 'subcategory' : 'category',
    };
  },
  [EDIT_CATEGORY]: (action, state) => {
    const category = getCategory(state, action.payload.categoryId);
    return {
      application_type: 'web',
      evid: 32,
      name: category.label,
      origin: action.payload.origin,
      isChanged: action.payload.isChanged,
      type: category.parentId ? 'subcategory' : 'category',
    };
  },
  [CREATE_CATEGORY]: action => {
    const category = action.payload.category;
    return {
      application_type: 'web',
      evid: 33,
      name: category.label,
      origin: action.payload.origin,
      type: 'category',
    };
  },
  [SELECT_FONT]: action => {
    return {
      evid: 52,
      font: action.payload.font,
      place: action.payload.place,
    };
  },
  [SELECT_FONT_SIZE]: action => {
    return {
      evid: 53,
      fontSize: action.payload.size,
      place: action.payload.place,
    };
  },
};

export const endpoint = 'forums-users';
export const src = 69;
